import Link from 'next/link'
import Image from 'next/image'
import { imgUrl } from '@bww/beke-lib/sanity-client'
import styles from './FeaturedProject.module.scss'
import classNames from 'classnames'

export default function FeaturedProject({ project }) {
  const { title, shortDescription, slug, heroImg } = project
  return (
    <section className={styles.container}>
      <div>
        <Image
          className={styles.image}
          src={imgUrl(heroImg).width(1500).url()}
          alt={heroImg.alt || title}
          width={750}
          height={500}
          priority
          // placeholder={heroImg?.lqip ? 'blur' : undefined}
          // blurDataURL={heroImg?.lqip}
        />
      </div>
      <div className={styles.panel}>
        <div>
          <h2 className={styles.panelTitle}>Featured Project</h2>
          <h3 className={classNames('h4', styles.title)}>{title}</h3>
          {shortDescription && <p>{shortDescription}</p>}
        </div>
        <div className={styles.buttonWrapper}>
          {/* <Link href={`/projects/${slug}`} className="button button--small"> */}
          <Link
            href={`/projects/${slug}`}
            className={classNames(
              styles.button,
              'button',
              'button--small',
              'button--expand',
            )}
          >
            View Project
          </Link>
        </div>
      </div>
    </section>
  )
}
